import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ClickOutsideModule } from 'ng-click-outside';

import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { PipeModule } from 'app/shared/pipes/pipe.module';

// COMPONENTS
import { FooterComponent } from './footer/footer.component';
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { VerticalMenuComponent } from './vertical-menu/vertical-menu.component';
import { CustomizerComponent } from './customizer/customizer.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';
import { NavbarComponent } from './navbar/navbar/navbar.component';

// DIRECTIVES
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { SidebarLinkDirective } from './directives/sidebar-link.directive';
import { SidebarDropdownDirective } from './directives/sidebar-dropdown.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebar-anchor-toggle.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { TopMenuDirective } from './directives/topmenu.directive';
import { TopMenuLinkDirective } from './directives/topmenu-link.directive';
import { TopMenuDropdownDirective } from './directives/topmenu-dropdown.directive';
import { TopMenuAnchorToggleDirective } from './directives/topmenu-anchor-toggle.directive';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ActionsDropdownComponent } from './components/actions-dropdown/actions-dropdown.component';
import { DragDropFileUploadDirective } from './directives/drag-drop-file-upload.directive';
import { OrganizationChooserComponent } from './components/organization-chooser/organization-chooser.component';
import { AuthDirectivesModule } from '../features/auth/directives/auth-directives.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalDirective } from './directives/modal.directive';
import { CustomDatePickerComponent } from './components/custom-date-picker/custom-date-picker.component';
import { IroyalImageComponent } from './components/iroyal-image/iroyal-image.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';


@NgModule({
    exports: [
        CommonModule,
        FooterComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarDirective,
        TopMenuDirective,
        NgbModule,
        TranslateModule,
        SpinnerComponent,
        ActionsDropdownComponent,
        ModalDirective,
        NavbarComponent,
        IroyalImageComponent,
        UploadFileComponent,
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        TranslateModule,
        FormsModule,
        OverlayModule,
        OverlayModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        ClickOutsideModule,
        AutocompleteModule,
        NgbDropdownModule,
        // TagInputModule,
        PipeModule,
        AuthDirectivesModule,
        NgSelectModule,
    ],
    declarations: [
        FooterComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        CustomizerComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarLinkDirective,
        SidebarDropdownDirective,
        SidebarAnchorToggleDirective,
        SidebarDirective,
        TopMenuLinkDirective,
        TopMenuDropdownDirective,
        TopMenuAnchorToggleDirective,
        TopMenuDirective,
        // TagsInputComponent,
        SpinnerComponent,
        ActionsDropdownComponent,
        DragDropFileUploadDirective,
        OrganizationChooserComponent,
        ModalDirective,
        CustomDatePickerComponent,
        NavbarComponent,
        IroyalImageComponent,
        UploadFileComponent,
    ],
})
export class SharedModule {}
